import { ca } from '@cian/analytics';
import { EVENT_TWO_FACTOR_MAPPER } from './types';
export function trackConfirmPhoneShown() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'verify_number_popup_show'
  });
}
export function trackConfirmPhoneConfirmClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'verify_number_popup_click'
  });
}
export function trackConfirmPhoneResendClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'verify_number_popup_retry'
  });
}
export function trackConfirmPhoneSucceed() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'verify_number_popup_success'
  });
}
/**
 * Открытие попапа двухфакторной авторизации
 */

export function trackTwoFactorPopupOpen(type) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Open',
    label: "".concat(type ? EVENT_TWO_FACTOR_MAPPER[type] : '', "reg_popup")
  });
}
/**
 * Открытие попапа двухфакторной авторизации
 */

export function trackTwoFactorClose(type) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Click',
    label: "".concat(type ? EVENT_TWO_FACTOR_MAPPER[type] : '', "close")
  });
}
/**
 * Открытие попапа после нескольких попыток ввода неправильного кода
 */

export function trackTwoFactorAttemptsExhaustedPopupOpen(type) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Fail',
    label: "".concat(type ? EVENT_TWO_FACTOR_MAPPER[type] : '', "fatal")
  });
}
export function trackTwoFactorInvalid(type) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Fail',
    label: "".concat(type ? EVENT_TWO_FACTOR_MAPPER[type] : '', "simple")
  });
}
export function trackTwoFactorWhatForClick(type) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Click',
    label: "".concat(type ? EVENT_TWO_FACTOR_MAPPER[type] : '', "what_for")
  });
}
export function trackTwoFactorContinueClick(type) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Click',
    label: "".concat(type ? EVENT_TWO_FACTOR_MAPPER[type] : '', "continue")
  });
}
export function trackTwoFactorResendClick(type) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Click',
    label: "".concat(type ? EVENT_TWO_FACTOR_MAPPER[type] : '', "send_again")
  });
}
export function trackTwoFactorCannotConfirmClick(type) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Click',
    label: "".concat(type ? EVENT_TWO_FACTOR_MAPPER[type] : '', "cant_confirm")
  });
}
export function trackTwoFactorAttemptsExhaustedSupportClick(type) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Click',
    label: "".concat(type ? EVENT_TWO_FACTOR_MAPPER[type] : '', "write_to_support")
  });
}
export function trackTwoFactorPhoneInputClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Authorization',
    action: 'Click',
    label: 'phone_input'
  });
}